import { ImgHTMLAttributes } from "react";

interface LogoProps extends ImgHTMLAttributes<HTMLImageElement> {
  fillWhite?: boolean;
}

export default function Logo(props: LogoProps) {
  const { width, height, style, fillWhite, ...otherProps } = props;

  return (
      <img
          src={fillWhite ? "/favicon-white.svg" : "/favicon.svg"}
          alt="Guude AI Logo"
          width={width || "100em"}
          height={height || "100em"}
          style={{ fontSize: "1.5rem", ...style }}
          {...otherProps}
      />
  );
}
